import React from 'react';
import {Inputfield} from '../Inputfield/Inputfield';

const SearchableDropdownToggle = React.forwardRef<any, any>(({onChange, placeholder, ...props}, ref) => (
  <Inputfield
    id='searchable-account-dropdown'
    ref={ref}
    value={props.value || ''}
    onChange={onChange}
    placeholder={placeholder}
    autoFocus={true}
    {...props}
  />
));

export default SearchableDropdownToggle;
